document.addEventListener('DOMContentLoaded', () => {
  // Verzamel unieke categorieën van de pagina
  const categories = new Set();
  document
    .querySelectorAll('.form__categorie')
    .forEach((elem) => categories.add(elem.textContent.trim()));

  // Maak een container voor de filters
  const filterContainer = document.createElement('ul');
  filterContainer.classList.add('filterList');

  // Maak filterknoppen voor elke categorie, inclusief 'Alle folders'
  const filterItems = ['Alle folders', ...categories].map((cat) => {
    const li = document.createElement('li');
    const button = document.createElement('a');
    button.textContent = cat;
    li.className = 'filterList__item';
    button.addEventListener('click', () => {
      applyFilter(cat.toLowerCase()); // Gebruik kleine letters voor URL-parameters
      updateActiveClass(cat); // Werk actieve klasse bij bij klikken
    });
    li.appendChild(button);
    filterContainer.appendChild(li);
    return li;
  });

  // Vind het leadFoldersIntro-element
  const introDiv = document.querySelector('.leadFoldersIntro');

  // Voeg de filtercontainer toe na het leadFoldersIntro-element
  introDiv.parentNode.insertBefore(filterContainer, introDiv.nextSibling);

  // Functie om het geselecteerde filter toe te passen
  function applyFilter(category) {
    const sanitizedCategory = sanitizeCategory(category);
    document
      .querySelectorAll(
        '.webform-type-webform-entity-checkboxes .formItem--checkbox',
      )
      .forEach((item) => {
        const catText = item
          .querySelector('.form__categorie')
          ?.textContent.trim();
        const sanitizedCatText = sanitizeCategory(catText);
        item.style.display = sanitizedCategory === 'alle-folders'
          || sanitizedCatText === sanitizedCategory
          ? ''
          : 'none';
      });
    updateURL(category); // Geef de oorspronkelijke categorie door aan updateURL
  }

  // Functie om de actieve klasse bij te werken op filteritems
  function updateActiveClass(category) {
    const sanitizedCategory = sanitizeCategory(category);

    // Verwijder de actieve klasse van alle filteritems
    filterItems.forEach((item) => item.classList.remove('active'));

    // Voeg de actieve klasse toe aan het geselecteerde filteritem (de <li>)
    const activeFilterItem = filterItems.find(
      (item) => sanitizeCategory(item.querySelector('a').textContent)
        === sanitizedCategory,
    );
    if (activeFilterItem) {
      activeFilterItem.classList.add('active');
    }
  }

  // Functie om de categorie te saniteren voor consistente vergelijking
  function sanitizeCategory(category) {
    if (!category) return '';
    return category
      .replace(/[\s+]+/g, '-')
      .replace(/--+/g, '-')
      .toLowerCase();
  }

  // Functie om de URL-parameter bij te werken op basis van het geselecteerde filter
  function updateURL(category) {
    const sanitizedCategory = sanitizeCategory(category);
    const params = new URLSearchParams(window.location.search);
    if (sanitizedCategory === 'alle-folders') {
      params.delete('categorie');
    } else {
      params.set('categorie', sanitizedCategory);
    }
    const newURL = params.toString()
      ? `${window.location.pathname}?${params.toString()}`
      : window.location.pathname;
    history.pushState(null, '', newURL);
  }

  // Controleer op de initiële categorie vanuit de URL en pas het filter toe
  const params = new URLSearchParams(window.location.search);
  const initialCategory = params.get('categorie') || 'Alle folders';
  applyFilter(initialCategory);

  // Werk de actieve klasse bij op basis van de initiële categorie
  updateActiveClass(initialCategory);
});
